export const SERVICE_TYPE_GET_REQUEST = 'SERVICE_TYPE_GET_REQUEST';
export const SERVICE_TYPE_GET_SUCCESS = 'SERVICE_TYPE_GET_SUCCESS';
export const SERVICE_TYPE_GET_ERROR = 'SERVICE_TYPE_GET_ERROR';
export const SERVICE_TYPE_GET_BY_KEY_REQUEST = 'SERVICE_TYPE_GET_BY_KEY_REQUEST';
export const SERVICE_TYPE_GET_BY_KEY_SUCCESS = 'SERVICE_TYPE_GET_BY_KEY_SUCCESS';
export const SERVICE_TYPE_GET_BY_KEY_ERROR = 'SERVICE_TYPE_GET_BY_KEY_ERROR';
export const SERVICE_TYPE_ADD_REQUEST = 'SERVICE_TYPE_ADD_REQUEST';
export const SERVICE_TYPE_ADD_SUCCESS = 'SERVICE_TYPE_ADD_SUCCESS';
export const SERVICE_TYPE_ADD_ERROR = 'SERVICE_TYPE_ADD_ERROR';
export const SERVICE_TYPE_EDIT_REQUEST = 'SERVICE_TYPE_EDIT_REQUEST';
export const SERVICE_TYPE_EDIT_SUCCESS = 'SERVICE_TYPE_EDIT_SUCCESS';
export const SERVICE_TYPE_EDIT_ERROR = 'SERVICE_TYPE_EDIT_ERROR';
export const SERVICE_TYPE_DELETE_REQUEST = 'SERVICE_TYPE_DELETE_REQUEST';
export const SERVICE_TYPE_DELETE_SUCCESS = 'SERVICE_TYPE_DELETE_SUCCESS';
export const SERVICE_TYPE_DELETE_ERROR = 'SERVICE_TYPE_DELETE_ERROR';

export const SERVICE_TYPE_PAYED = 1;
export const SERVICE_TYPE_GOVERNMENT = 2;
